// src/data/BrandItems.js
const brandItems = [
  {
    src: "/assets/images/ally_one.png",
    alt: "Servicios Maxicolors",
    tag: "",
    since: 2021,
    verified: false,
    featured: true,
    url: "https://www.instagram.com/serviciosmaxicolors?igsh=cXI4d3RhcjJmNXQx", 
  },
  {
    src: "/assets/images/ally_two.png",
    alt: "Carpintería Las 3 A",
    tag: "",
    since: 2019,
    verified: false,
    featured: false,
    url: "https://www.instagram.com/carpinteria_las3a?igsh=N2ZtcWkzNnZ2OG5t",
  },
  {
    src: "/assets/images/ally_three.png",
    alt: "Inyishop",
    tag: "",
    since: 2020,
    verified: false,
    featured: true,
    url: "https://www.instagram.com/inyi_shop?igsh=dnJ3bmJ3Y2g2bmZw",
  },
  {
    src: "/assets/images/ally_six.svg",
    alt: "Zafe",
    tag: "",
    since: 2022,
    verified: true,
    featured: false,
    url: "https://zafe.global/",
  },
  {
    src: "/assets/images/ally_five.jpeg",
    alt: "RapiTaller+",
    tag: "",
    since: 2025,
    verified: true,
    featured: false,
    url: "https://rapitaller.com/",
  },
  {
    src: "/assets/images/ally_seven.png",
    alt: "Nethree",
    tag: "",
    since: 2025,
    verified: true,
    featured: false,
    url: "https://play.google.com/store/apps/details?id=com.nethree.app&hl=es",
  },
  {
    src: "/assets/images/ally_four.png",
    alt: "GodPrint",
    tag: "",
    since: 2022,
    verified: true,
    featured: false,
    url: "https://godprint.com",
  },
    {
    src: "/assets/images/anproseg.png",
    alt: "Anproseg",
    tag: "",
    since: 2025,
    verified: true,
    featured: false,
    url: "https://www.anproseg.com/",
  },
];

export default brandItems;
